module.exports = function(service) {
	'use strict'
	service.factory('activeClass',activeClass);
	activeClass.$inject=['jQuery'];
	function activeClass(jQuery) {
		return {
			active: function(event) {
				var target = event.target;
	           	var siblings = jQuery(target).parent('li').siblings('li');
	            for (var i=0; i<siblings.length; i++){
	              jQuery(siblings[i]).find('a').removeClass('active')
	            }
	            jQuery(target).addClass('active');
        	}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/activeClassService.js
// module id = 580
// module chunks = 0